var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1265_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7709 27.7695L17.5991 18.5977C16.8667 19.2212 16.0244 19.7039 15.0723 20.0456C14.1202 20.3874 13.1634 20.5583 12.202 20.5583C9.8559 20.5583 7.87024 19.7462 6.24504 18.122C4.62009 16.4978 3.80762 14.5133 3.80762 12.1687C3.80762 9.82379 4.61973 7.83764 6.24394 6.21025C7.86816 4.5831 9.8526 3.76953 12.1973 3.76953C14.5422 3.76953 16.5283 4.58201 18.1557 6.20696C19.7828 7.83215 20.5964 9.81781 20.5964 12.1639C20.5964 13.1817 20.4161 14.1667 20.0555 15.1188C19.695 16.0709 19.2217 16.885 18.6358 17.561L27.8076 26.7332L26.7709 27.7695ZM12.202 19.0935C14.1456 19.0935 15.7864 18.4245 17.1245 17.0864C18.4626 15.7485 19.1316 14.1077 19.1316 12.1639C19.1316 10.2201 18.4626 8.57932 17.1245 7.24147C15.7864 5.90338 14.1456 5.23433 12.202 5.23433C10.2582 5.23433 8.61741 5.90338 7.27956 7.24147C5.94146 8.57932 5.27242 10.2201 5.27242 12.1639C5.27242 14.1077 5.94146 15.7485 7.27956 17.0864C8.61741 18.4245 10.2582 19.0935 12.202 19.0935Z",
    fill: "#32302C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1265_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.172fbcc1a2f4f994d5855a59ffb87ceb.svg";
export { ForwardRef as ReactComponent };